import Vue from 'vue'

import VueLodash from 'vue-lodash'
import { pick, get, debounce } from 'lodash'

Vue.use(VueLodash, { name: 'custom', lodash: { pick, get, debounce } })
